<template>
  <div>
    <Doughnut :type="'doughnut'" :options="chartOptions" :data="chartData" :height="heightDg" :plugins="pluginsDevoir" />
  </div>
</template>
    <script>
import {Doughnut} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale} from "chart.js";
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale);
export default {
  name: "DonutCharts",
  components: {Doughnut},
  props: {
    chartData: {
      type: Object,
      default: {},
    },
    pluginsDevoir: {
      type: Object,
      default: {},
    },
    heightDg: {
      type: Number,
      default: 300,
    },
    cutoutDg: {
      type: Number,
      default: 100,
    },
    position: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        cutout: this.cutoutDg,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: this.position,
            labels: {
              textAlign: "center",
              usePointStyle: true,
              pointStyle: "rectRounded",
              boxWidth: 80,
            },
            align: "center",
          },
          doughnutlabel: {
            labels: [
              {
                text: "550",
                font: {
                  size: 20,
                  weight: "bold",
                },
              },
              {
                text: "total",
              },
            ],
          },
        },
      },
    };
  },
};
</script>
<style>
#nb-devoir {
  font-weight: 700;
  font-size: 50px !important;
  line-height: 61px;
  color: #1c1c1c !important;
}
</style>